import React, { useState, useEffect } from 'react';
import { Tree, Tabs, Empty, Tooltip } from 'antd';
import { CaretDownOutlined, FileTextOutlined, FolderOpenOutlined, FolderOutlined,} from '@ant-design/icons';
import Iconfont from "../../../../components/Iconfont/Iconfont";
// import storage from "../../../utils/storage";

import "./index.scss";

const {DirectoryTree} = Tree;

const OverseasCaseTree = ({
    treeDate,
    changePolicyTree,
    selectedNode,
    menuClickFunc,
    expandedKeyList,
    treeType,
    onOverseasCaseTreeChange
}) => {
    const [activeNode, setActiveNode] = useState(null);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [menuStyle, setMenuStyle] = useState({});

    const [expandedKeys, setExpandedKeys] = useState([]);

    const menuList = [
        // {text: "新增子分类", icon: "icon-add", key: "addSort",},
        // {text: "新增文件夹", icon: "icon-xinjian", key: "addTheme",},
        {text: "编辑", icon: "icon-edit1", key: "edit",},
        {text: "删除", icon: "icon-shanchu1", key: "delete",},
    ];

    const typeItems = [
        { label: '项目地点', key: '2'}, // 务必填写 key
        { label: '项目年份', key: '1'},
        { label: '项目阶段', key: '3'},
    ];

    useEffect(() => {
        window.addEventListener("click", cancelActiveNode);
        if (!(selectedNode?.id)) {
            const node = firstPolicy(treeDate);
            if (node) {
                changePolicyTree(node);
            }
        }
        return () => {
            window.removeEventListener("click", cancelActiveNode)
        }
    }, [])

    useEffect(() => {
        if(expandedKeyList && expandedKeyList.length > 0){
            setExpandedKeys([...expandedKeyList]);
        }
    }, [expandedKeyList])

    useEffect(() => {
        const node = firstPolicy(treeDate);
        changePolicyTree(node);
    }, [treeDate])

    // 高亮显示第一个主题节点
    function firstPolicy (list) {
        for (const item of list) {
            if (String(item.type) === "1") {
                return item;
            } else if (item.children?.length > 0) {
                return firstPolicy(item.children);
            }
        }
        return undefined;
    }

    // 取消右键选中
    function cancelActiveNode () {
        setActiveNode(null);
        setMenuIsOpen(false);
        const domList = document.getElementsByClassName("activeNodeStatus");
        for (let domListElement of domList) {
            domListElement.className = domListElement.className.replace(/\s+activeNodeStatus/g, "");
        }
    }

    const titleRender = (nodeData) => {
        const domId = `nodeId-${nodeData.id}`;
        return (
            <span id={domId} style={{whiteSpace: "pre-wrap", wordBreak: "break-all",}}>
                {nodeData.octName}
                {nodeData.count ? `(${nodeData.count})`: ""}
            </span>
        );
    }

    const onSelect = (selectedKeys, e) => {
        const node = e.node;
        if (treeType === "view") {
            if (e.selected) {
                changePolicyTree(e.node)
            }
        } else {
            changePolicyTree(e.selected ? e.node : null)
        }
    }

    const onRightMenuFunc = ({event, node}) => {
        
        if (treeType !== "view" &&  node.updateStutas) {
            
            const domList = document.getElementsByClassName("activeNodeStatus");
            for (let domListElement of domList) {
                domListElement.className = domListElement.className.replace(/\s+activeNodeStatus/g, "");
            }
            const domId = `nodeId-${node.id}`;
            let targetDom = document.getElementById(domId);
            if (targetDom) {
                let dom = targetDom.parentNode.parentNode;
                if (dom) {
                    dom.className += " activeNodeStatus";
                    setActiveNode(node);
                    
                    setMenuStyle({
                        width: dom.clientWidth,
                        height: dom.clientHeight,
                        top: dom.offsetTop + 60,
                        left: dom.offsetLeft - 8,
                    });
                    setMenuIsOpen(true);
                }
            }
        }
    }

    const menuClick = (key, activeNode) => {
        setMenuIsOpen(false);
        menuClickFunc(key, activeNode);
    }

    const onExpand = (expandedKeys, e) => {
        console.log(expandedKeys, e,"expandedKeys, e")
        let id = e.node.id;
        if(e.expanded){
            let _expandedKeys = [...expandedKeys,id]
            setExpandedKeys(_expandedKeys);
        }else{
             let _expandedKeys = expandedKeys.filter((item) => {
                return item != id
            });
            console.log(_expandedKeys,"_expandedKeys")
            setExpandedKeys(_expandedKeys)
        }
    }

    const {type, id: activeId, children, paramJson} = activeNode || {};

    const selectedKeys = selectedNode?[selectedNode.tagIdOctIdStr]:[];
    
    return(
        <div className="policyTreeFrame">

            <Tabs 
                items={typeItems} 
                onChange={onOverseasCaseTreeChange}
            />

            {
                treeDate && treeDate.length > 0 ?
                    (
                        <Tree
                            showIcon={true}
                            icon={(item) => {
                                const isTheme = String(item.type) === "1";
                                return isTheme ? <FileTextOutlined /> : (item.expanded ? <FolderOpenOutlined /> : <FolderOutlined />);
                            }}
                            switcherIcon={<CaretDownOutlined />}
                            treeData={treeDate}
                            onSelect={onSelect}
                            onRightClick={onRightMenuFunc}
                            titleRender={titleRender}
                            selectedKeys={selectedKeys}
                            expandedKeys={[...expandedKeys]}
                            onExpand={onExpand}
                            // defaultExpandAll={true}
                            blockNode
                            fieldNames={{
                                title:"octName",
                                key: "tagIdOctIdStr",
                                children:"children",
                                isLeaf:"type",
                            }}
                        />
                    )
                    :
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            }

            <Tooltip
                disabled={treeType === "view"}
                placement={"right"}
                open={menuIsOpen}
                key={activeId}
                overlayClassName="menuToolTipBox"
                trigger={"contextMenu"}
                title={(
                    <div
                        className="menuBox"
                        onClick={(e) => e?.stopPropagation()}
                    >
                        {
                            menuList.map(item => {
                                const {text, icon, key} = item;
                                let content = (
                                    <div
                                        className="menuItem"
                                        key={key}
                                        onClick={() => menuClick(key, activeNode)}
                                    >
                                        <Iconfont type={icon}></Iconfont>
                                        <span className="menuText">{text}</span>
                                    </div>
                                );
                                switch (key) {
                                    case "delete":
                                            content = (
                                                <div
                                                    className="menuItem"
                                                    key={key}
                                                    onClick={() => menuClick(key,activeNode)}
                                                >
                                                    <Iconfont type={icon}></Iconfont>
                                                    <span className="menuText">{text}</span>
                                                </div>
                                            )
                                        break;
                                    case "edit":
                                        if(!paramJson){
                                            content = null;
                                        }
                                        break;
                                }

                                return content;
                            })
                        }
                    </div>
                )}
            >
                <div style={menuStyle} className="menuRootNode"></div>
            </Tooltip>
        </div>
    )
}

export default OverseasCaseTree;
